import { useTranslation } from 'next-i18next';
import { DurationFormatter } from '../../../../../components/SearchForm/components/TravelPeriodField/utils.js';
export const useTravelDurationLabelNew = ({
  minDuration,
  maxDuration,
  short = false,
  isInput
}) => {
  const {
    t
  } = useTranslation();
  if (minDuration === 0 && maxDuration === 0) {
    return t(`travelPeriodWidgetNew:chipLabel.exact.${short ? 'short' : 'long'}`);
  }
  if (!minDuration || !maxDuration) {
    return '';
  }
  if (minDuration === maxDuration) {
    // If text input is used, week formatting should be done based on the input value, not the state value
    const value = isInput ? DurationFormatter.format(maxDuration) : maxDuration;
    const weeks = Math.floor(value / 7);
    const days = value % 7;
    if (weeks && days === 0) {
      return t(`travelPeriodWidgetNew:chipLabel.xWeeksLong`, {
        count: weeks
      });
    }
    const displayedValue = DurationFormatter.format(maxDuration);
    return t(`travelPeriodWidgetNew:chipLabel.xDaysLong`, {
      days: displayedValue,
      count: displayedValue
    });
  }
  const displayedMax = DurationFormatter.format(maxDuration);
  const displayedMin = DurationFormatter.format(minDuration);
  return t(`travelPeriodWidgetNew:chipLabel.xDaysLongForcePlural`, {
    days: `${displayedMin} - ${displayedMax}`
  });
};